export const CreditCardPaneComponent = {
    template: `

        <oo-edit-pane
            on-delete="$ctrl.onDelete()"
            missing-data="false">
            <oo-read-state>
                <button
                    class="button button-link pull-right delete-button"
                    type="button"
                    ng-click="$ctrl.onMakePrimary()"
                    ng-if="!$ctrl.creditCard.isPrimary"
                    >Make Primary</button>
                <credit-card-card delete="true" card="$ctrl.creditCard"></credit-card-card>
            </oo-read-state>
        </oo-edit-pane>
        <modal
            title="Delete Card"
            open="$ctrl.showDialog"
            show-close-button="false"
        >
            <modal-content>
                <p c-type="body-sm-primary">Please confirm that you want to delete this card from your account</p>
            </modal-content>
            <modal-footer>
                <button ng-click="$ctrl.cancel()" c-button="link">Cancel</button>
                <button ng-click="$ctrl.confirm()" c-button="primary">Delete</button>
            </modal-footer>
        </modal>
    `,
    bindings: {
        creditCard: '<',
    },
    controller: class {
        constructor(accountService) {
            'ngInject';
            this.accountService = accountService;
        }

        cancel() {
            this._closeDialog();
        }

        confirm() {
            this.accountService.deleteCard(this.creditCard.guid);
            this._closeDialog();
        }

        onDelete() {
            this._openDialog();
        }

        onMakePrimary() {
            this.accountService.makePrimary(this.creditCard.guid);
        }

        _openDialog() {
            this.showDialog = true;
        }

        _closeDialog() {
            this.showDialog = false;
        }
    }
};
